import { gql } from '@apollo/client'

const createReorderQuoteFromOrderMutation = gql`
    mutation createReorderQuoteFromOrder($orderName: String!, $userId: Int) {
        createReorderQuoteFromOrder(orderName: $orderName, userId: $userId) {
            id
            name
        }
    }
`

export default createReorderQuoteFromOrderMutation
